import React, { useState, useEffect } from "react";
import { useDataContext } from "../../../contexts/Context";
import ReactPaginate from "react-paginate";
import Items from "./Items";

export default function PaginatedItems() {
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const { cards } = useDataContext();
  const itemsPerPage = 4;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(cards?.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(cards?.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, cards]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % cards?.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <Items currentItems={currentItems} />
      <ReactPaginate
        breakLabel="..."
        nextLabel="Next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="< Previous"
        renderOnZeroPageCount={null}
        containerClassName={"container"}
        disabledClassName={"disabled"}
        activeLinkClassName={"active"}
      />
    </>
  );
}
